import styled from "styled-components";
import Modal from "../../components/Modal";
import { useState, useContext, useEffect } from "react";
import FlexBox, { FlexGrow } from "../../components/FlexBox";
import { ClickableIcon } from "../../components/Icon";
import Button from "../../components/Button";
import Status from "../../types/enum/Status";
import { Icon } from "@mui/material";
import Input, { InputTextArea } from "../../components/Input";
import { EmptyAnnouncement } from "../../types/Announcement";
import CategorySelect from "../../components/CategorySelect";
import axios from "axios";
import { UserContext } from "../../context/UserContext";
import Program, { EmptyProgram } from "../../types/Program";
import MinimalSelect from "../../components/MinimalSelect";
import { UniversityContext } from "../../context/UniversityContext";

type CreateAnnoucementModal = {
  fetchAnnouncement: () => void;
  isOpen?: boolean;
  isMobile?: boolean;
  setOpen: (x: boolean) => void;
  setMessageHeader: (x: string) => void;
  setMessageType: (x: "error" | "success" | "warning" | "info") => void;
  setIsMessageOpen: (x: boolean) => void;
  setMessage: (x: string) => void;
};

export const CreateAnnoucementModal = ({
  fetchAnnouncement,
  isOpen,
  setOpen,
  isMobile,
  setMessageHeader,
  setMessageType,
  setIsMessageOpen,
  setMessage,
}: CreateAnnoucementModal): JSX.Element => {
  const HeaderBox = styled(FlexBox)`
    display: flex;
    align-items: center;
    padding: 12px 12px;
    background: #090d20;
    font-weight: bold;
    color: #ffffff;
  `;

  const [announcementData, setAnnouncementData] =
    useState<any>(EmptyAnnouncement);
  const universityContext = useContext(UniversityContext);
  const [selectedProgram, setSelectedProgram] = useState<Program>(
    universityContext.selectedProgram
  );
  const { user } = useContext(UserContext);

  const submitCreate = (e: any) => {
    e.preventDefault();
    const data = {
      ...announcementData,
      creator: user.name,
      email: user.email,
      program_name: selectedProgram.value === "ALL" ? "" : selectedProgram.value,
      university_code: user.university_code,
    };
    axios
      .post("/announcement/new", data)
      .then((res) => {
        setOpen(false);
        fetchAnnouncement();
        setMessageType("success");
        setMessageHeader("Created!");
        setMessage("Announcement has been created!");
        setIsMessageOpen(true);
      })
      .catch((err) => {
        setMessageType("error");
        setMessageHeader("Failed!");
        setMessage(err.response.data.error);
        setIsMessageOpen(true);
      });
  };
  return (
    <Modal
      isOpen={isOpen || false}
      setOpen={setOpen}
      customStyle={{
        content: {
          maxWidth: "800px",
          padding: 0,
          background: "#090d20",
          // border: "1px solid #2D416C",
          boxShadow: "0px 4px 16px rgba(0,0,0)",
          borderRadius: "8px",
        },
      }}
    >
      <HeaderBox>
        <Icon
          sx={{
            // color: "#ffff86",
            mr: 1,
            textShadow: "0 1px 5px black",
          }}
        >
          add_circle_outline_icon
        </Icon>
        <FlexGrow>Add Announcement</FlexGrow>
        <ClickableIcon
          name="times"
          onClick={() => setOpen(false)}
          style={{ color: "white" }}
        />
      </HeaderBox>
      <form
        onSubmit={(e) => submitCreate(e)}
        style={{
          padding: 30,
          display: "grid",
          gridTemplateColumns: "15% 85%",
          rowGap: 15,
        }}
      >
        Program
        <MinimalSelect
          styles={{
            container: (base) => ({
              ...base,
              // width: "100%",
              minWidth: "100%",
              marginRight: "8px",
              zIndex: 9999
            }),
            menu: (base) => ({
              ...base,
              // width: "max-content",
              minWidth: "100%",
            }),
            menuPortal: (baseStyles, state) => ({
              ...baseStyles,
              zIndex: 999999999,
            }),
            control: (baseStyles, state) => ({
              ...baseStyles,
              color: "white !important",
              cursor: "default !important",
            }),
            input: (baseStyles, state) => ({
              ...baseStyles,
              color: "white !important",
            }),
          }}
          setClass={"custom-container"}
          required
          placeholder="Program"
          options={[{label:"ALL Programs", value:""},...universityContext.programs]}
          value={selectedProgram}
          onChange={(newValue: any) => {
            setSelectedProgram(newValue);
          }}
        />
        Category
        <CategorySelect
          required
          selectedView={announcementData.category}
          setSelectedView={(e: any) =>
            setAnnouncementData({
              ...announcementData,
              announcement_category: e.value,
            })
          }
        />
        Title
        <Input
          onInput={(e: React.ChangeEvent<HTMLInputElement>) =>
            setAnnouncementData({
              ...announcementData,
              [e.target.name]: e.target.value,
            })
          }
          maxLength={64}
          required
          isFullWidth
          id="title"
          name="title"
          placeholder="Title"
          value={announcementData.title}
          style={{ color: "white" }}
        />
        Content
        <InputTextArea
          className="visible-scrollbar"
          maxLength={2048}
          onChange={(e: any) =>
            setAnnouncementData({
              ...announcementData,
              [e.target.name]: e.target.value,
            })
          }
          isFullWidth
          required
          id="content"
          name="content"
          placeholder="Content"
          value={announcementData.content}
          style={{ color: "white" }}
        />
        URL
        <Input
          onInput={(e: React.ChangeEvent<HTMLInputElement>) =>
            setAnnouncementData({
              ...announcementData,
              [e.target.name]: e.target.value,
            })
          }
          // required
          maxLength={2048}
          isFullWidth
          id="url"
          name="url"
          placeholder="URL"
          value={announcementData.url}
          style={{ color: "white" }}
        />
        <>&nbsp;</>
        <FlexBox justify="end" style={{ paddingTop: 10 }}>
          <Button
            type="button"
            style={{
              width: isMobile ? "80px" : "150px",
              height: "48px",
            }}
            isOutline
            status={Status.default}
            onClick={() => setOpen(false)}
          >
            Cancel
          </Button>
          <FlexGrow style={{ flexGrow: "0" }}>
            <Button
              type="submit"
              style={{
                width: isMobile ? "80px" : "150px",
                height: "48px",
                padding: "13px 12px",
              }}
              status={Status.button}
            >
              Create
            </Button>
          </FlexGrow>
        </FlexBox>
      </form>
    </Modal>
  );
};
